import axiosInstance from "../../utils/axiosConfig";
import React, { useEffect, useMemo, useState } from "react";
import { TailSpin } from "react-loader-spinner";

import { DataTable } from "../../components/data-table";
import { API_URL } from "../../constant";
import { useAuth } from "../../context/auth-context";
import {
  buildPayrollActivityRows,
  createPayrollActivityColumns,
  PAYROLL_TABLE_LIMIT,
  type PayrollActivityRow,
} from "./payrollActivitiesTable";

const PayrollActivities = () => {
  const { isAuthenticated } = useAuth();
  const [records, setRecords] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);

  useEffect(() => {
    if (!isAuthenticated) return;
    setLoading(true);
    axiosInstance
      .get(
        `${API_URL}api/payroll?page=${page}&limit=${PAYROLL_TABLE_LIMIT}&status=paid`
      )
      .then((r: any) => {
        setRecords(
          Array.isArray(r?.data?.data?.records) ? r.data.data.records : []
        );
        setTotalPages(Math.max(1, r?.data?.data?.pagination?.totalPages ?? 1));
        setTotalRecords(
          r?.data?.data?.pagination?.totalRecords ??
            r?.data?.data?.pagination?.totalItems ??
            0
        );
      })
      .catch((e: any) => {
        console.log(e?.response?.data?.message || "An error occurred");
      })
      .finally(() => setLoading(false));
  }, [isAuthenticated, page]);

  const columns = useMemo(() => createPayrollActivityColumns(), []);
  const rows = useMemo<PayrollActivityRow[]>(
    () => buildPayrollActivityRows(records),
    [records]
  );

  if (loading && records.length === 0) {
    return (
      <div className="flex justify-center rounded-xl border border-[#2C363E] bg-[#161E25]/40 py-16">
        <TailSpin color="#0B75C2" height={36} width={36} />
      </div>
    );
  }

  return (
    <div className="w-full pb-8">
      {loading && (
        <p className="mb-2 text-[12px] text-[#869AA9]">Updating list…</p>
      )}
      <DataTable<PayrollActivityRow>
        columns={columns}
        data={rows}
        currentPage={page}
        setCurrentPage={setPage}
        totalPage={totalPages}
        count={totalRecords || undefined}
        limit={PAYROLL_TABLE_LIMIT}
        emptyContent="No payroll activity to display."
        className="overflow-hidden rounded-xl border border-[#2C363E]"
        fixedBodyHeight="min(620px, 60vh)"
      />
    </div>
  );
};

export default PayrollActivities;
